import { useState } from "react";
import { ShareIcon } from "assets/icons";
import Avatar from "components/BaseWidgets/Avatar";
import Button from "components/BaseWidgets/button";
import Tag from "components/BaseWidgets/tag";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import ShareModal from "components/CustomWidgets/shareModal";
import { displayTextOrDash } from "utils/formatHelper";
import defaultImage from 'assets/images/png/default-user.png'

function BlogCard({ blog, className, requestType }) {
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const handleCancel = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleImageClick = () => {
    navigate(`/blog/details/${blog.id}`, {
      state: { requestType },
    });
  };

  return (
    <>
      <div className={`blog-card ${className ? className : ""}`}>
        <div className="blog-image-card" onClick={handleImageClick}>
          <img
            src={blog.image ? blog?.image : defaultImage}
            alt={`Image for blog titled "${blog?.head}"`}
            className="blog-image"
          />
          <div className="blog-votes">
            <Tag variant="like"> {blog?.total_likes?.toLocaleString()}</Tag>
            <Tag variant="dislike">
              {" "}
              {blog?.total_dislikes?.toLocaleString()}
            </Tag>
          </div>
        </div>
        <div className="blog-content">
          <div className="title-share-wrap">
            <h3 className="blog-title font-title-xs fw-700">
              {displayTextOrDash(blog?.head)}
            </h3>
            <Button
              onClick={handleOpenModal}
              variant="custom"
              className="share-icon"
            >
              <ShareIcon />
            </Button>
          </div>
          <div className="author">
            <Avatar
              className="mr-2"
              text={blog?.blog_written_by_name}
              url={blog?.blog_written_by_image}
            />
            <div className="author-name">
              <span className="name description">
                {displayTextOrDash(blog?.blog_written_by_name)}
              </span>
              <span className="time font-body-normal fw-400">
                {displayTextOrDash(blog?.time)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <ShareModal
        open={openModal}
        onCancel={handleCancel}
        defaultLink={blog?.share_url}
      />
    </>
  );
}

export default BlogCard;
